var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#EAFAF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.084 31V17.0625C32.084 16.5 32.5215 16 33.084 16C40.7715 16 47.084 22.3125 47.084 30C47.084 30.5625 46.584 31 46.0215 31H32.084ZM15.084 33C15.084 25.4375 20.709 19.1875 28.0215 18.1875C28.584 18.0625 29.084 18.5625 29.084 19.125V34L38.834 43.8125C39.2715 44.25 39.209 44.9375 38.7715 45.25C36.2715 47 33.2715 48 30.084 48C21.7715 48 15.084 41.3125 15.084 33ZM47.959 34C48.5215 34 49.0215 34.5 48.8965 35.0625C48.459 38.5625 46.7715 41.6875 44.2715 44C43.8965 44.3125 43.334 44.3125 42.959 43.9375L33.084 34H47.959Z",
    fill: "#2FB273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.f91eaf2a3f7d0331e81d2218528c224e.svg";
export { ForwardRef as ReactComponent };